import { getters } from './getters';
import { mutations } from './mutations';
import { actions } from './actions';

const data = {
  bankAccount: {},
  bankAccountLoadingStatus: false,
  documents: [],
  documentsLoadingStatus: '',
  filingDecision: null,
  filingDecisionStatus: '',
  closeLoadingStatus: '',
  proofFiles: [],
  proofLoadingStatus: '',
  proofUploaded: false,
  backToDecisionPermission: false,
};

export default {
  state: data,
  getters,
  mutations,
  actions,
};
